import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight, Mail, RefreshCw, XCircle } from "lucide-react";
import SpaceJetNavbar from "../components/SpaceJetNavbar";
import SpaceJetParticleField from "../components/SpaceJetParticleField";
import { ThemeProvider } from "../contexts/ThemeContext";

const SpaceJetNetworkSignupFailure = () => {
  const [searchParams] = useSearchParams();
  const signupType = searchParams.get('type') === 'advertiser' ? 'advertiser' : 'affiliate';

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-[#050b17] text-slate-100 spacejet-texture-dots spacejet-texture-living transition-colors duration-300" style={{ '--spacejet-texture-dot-opacity': 0.105, '--spacejet-texture-grid-opacity': 0.07, '--spacejet-texture-ambient-opacity': 0.085, '--spacejet-texture-drift-duration': '50s', '--spacejet-texture-glow-duration': '35s', '--spacejet-texture-sheen-duration': '41s' }}>
        <SpaceJetNavbar />
        <SpaceJetParticleField maxParticles={28} speed={0.12} baseOpacity={0.18} />

        <section className="relative overflow-hidden py-20">
          <div className="absolute inset-0 spacejet-gradient-overlay" />
          <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
            <div className="spacejet-surface-card rounded-2xl p-12">
              <div className="mb-8 inline-flex h-20 w-20 items-center justify-center rounded-full bg-[linear-gradient(180deg,rgba(30,41,59,0.9),rgba(15,23,42,0.95))] border border-red-500/20">
                <XCircle className="h-10 w-10 text-red-200" />
              </div>

              <div className="spacejet-page-kicker mb-4 justify-center">Submission issue</div>
              <h1 className="spacejet-page-title text-4xl font-semibold text-slate-100 md:text-5xl">Application submission failed</h1>

              <p className="spacejet-page-copy mx-auto mt-6 max-w-2xl text-xl">
                {signupType === 'advertiser'
                  ? 'We encountered an issue while saving your advertiser sign-up. Please try again or contact support for assistance.'
                  : 'We encountered an issue while processing your publisher application. Please try again or contact support for assistance.'}
              </p>

              <div className="mx-auto mt-8 max-w-2xl rounded-xl border border-white/[0.08] bg-white/[0.03] p-6 text-left">
                <div className="mb-4 flex items-center justify-center gap-3 text-center">
                  <Mail className="h-6 w-6 text-slate-300" />
                  <h3 className="text-lg font-semibold text-slate-100">What you can do</h3>
                </div>
                <div className="space-y-2 text-slate-300">
                  <p>• Try submitting your application again</p>
                  <p>• Check that all required fields are filled correctly</p>
                  <p>• Contact our support team if the issue persists</p>
                  <p>• Email us at growth@spacejetmedia.com for help</p>
                </div>
              </div>

              <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row">
                <Link to="/signup" className="spacejet-btn-primary group inline-flex items-center justify-center rounded-lg px-8 py-4 font-semibold transition-colors duration-200">
                  <RefreshCw className="mr-2 h-5 w-5" />
                  Try again
                </Link>
                <Link to="/" className="spacejet-btn-secondary inline-flex items-center justify-center rounded-lg px-8 py-4 font-semibold transition-colors duration-200 hover:bg-white/[0.04]">
                  Back to home
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </ThemeProvider>
  );
};

export default SpaceJetNetworkSignupFailure;
